import React from 'react';
import Banner from '../../../components/Banner/Banner';
import './MalzemeTestVeAnalizleri.css';

const MalzemeTestVeAnalizleri = () => {
  // The following string contains the HTML for the data table.
  const emCalkanlamaTableHTML = `
  <table class="tablesorter eael-data-table center" id="eael-data-table-f00b028">
    <thead>
      <tr class="table-header">
        <th><span class="data-table-header-text"><center>ANALİZ</center></span></th>
        <th><span class="data-table-header-text"><center>FİYAT(TL)</center></span></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="td-content-wrapper"><div class="td-content">
            <center>EM Kalkanlama</center>
            <center>50 MHz-20 GHz</center>
            <center>Dalga Kılavuzu veya Geniş Band Horn Anten Yöntemi</center>
          </div></div>
        </td>
        <td>
          <div class="td-content-wrapper"><div class="td-content">
            <center>2910 TL (+ KDV)</center>
          </div></div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="td-content-wrapper"><div class="td-content">
            <center>Dielektrik Sabit ve Tanjant Kayıp</center>
            <center>50 MHz-20 GHz</center>
            <center>Dalga Kılavuzu veya Geniş Band Horn Anten Yöntemi</center>
          </div></div>
        </td>
        <td>
          <div class="td-content-wrapper"><div class="td-content">
            <center>2910 TL (+ KDV)</center>
          </div></div>
        </td>
      </tr>
    </tbody>
  </table>
  `;

  const dataTableHTML = `
<table class="tablesorter eael-data-table center" id="eael-data-table-c247731">
  <thead>
    <tr class="table-header">
      <th><span class="data-table-header-text"><center>ANALİZ</center></span></th>
      <th><span class="data-table-header-text"><center>TEST STANDARDI / TEST STANDARD</center></span></th>
      <th><span class="data-table-header-text"><center>ANALİZ</center></span></th>
      <th><span class="data-table-header-text"><center>ANALYSIS</center></span></th>
      <th><span class="data-table-header-text">FİYAT (TL) / PRICE (TL)</span></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>TS 259 EN 24920</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Tekstil- Kumaşlar- Yüzey<br />ıslanmasına karşı direncin tayini <br />(püskürtme metodu)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Textiles, determination of<br />resistance to surface wetting<br />(spray test) of fabrics</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>396</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>2</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>TS 257 EN 20811, DIN 5387, ASTM D 731, JIS L 1096</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Tekstil kumaşları-Su <br />geçirmezlik tayini hidrostatik<br />basınç deneyi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Textiles Fabrics-Determination <br />of Resistance to Water <br />Penetration-Hydrostatic<br />Pressure Test.</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>3</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>TS 391 ISO 9237, DIN 53887, ASTM D 737, JIS L 1096</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Tekstil kumaşları-Hava Geçirgenlik Testi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Textiles Fabrics-Standard Test Method for<br />Air Permeability of Textile Fabrics</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>324</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>4</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM F 316, DIN 58355, ASTM E 1294</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Methods for Pore <br />Size Characteristics of <br />Membrane Filters by Bubble <br />Point and Mean Flow Pore Test<br />DIN 58355-1<br />Membrane filters – Part 1: <br />Testing for specific liquid flow <br />rate for flat filters<br />ASTM E2813 – 12e1<br />Standard Practice for Building <br />Enclosure Commissioning</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1332</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>5</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E 96</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Su Buharı Geçirgenliği</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Methods for <br />Water Vapor Transmission of <br />Materials</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>720</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>6</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>EN ISO 6530</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Protective clothing – Protection <br />against liquid chemicals – <br />Test method for resistance of <br />materials to penetration <br />by liquids</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1440</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>7</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ISO 17473</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Taşınmalı Isı Direnci</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>810</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>8</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ISO 6942</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Protective clothing – Protection <br />against heat and fire – Method <br />of test: Evaluation of materials <br />and material assemblies when <br />exposed to a source of radiant <br />heat</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>864</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>9</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E 1348</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for<br />Steady-State Thermal<br />Transmission Properties by<br />Means of the Heat Flow<br />Meter Apparatus</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1260</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>10</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E 831</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for<br />Linear Thermal Expansion<br />of Solid Materials by<br />Thermomechanical Analysis</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1260</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>11</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>AATCC 6538</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Staphylococcus aureus<br />Antibacterial Activity<br />Assessment of Textile Materials</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>3600</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>12</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>AATCC 4552</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Klebsiella pneumoniae<br />bakterisine karşı</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>3600</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>13</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM C 518</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for<br />Steady-State Thermal<br />Transmission Properties by<br />Means of the Heat Flow<br />Meter Apparatus</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>468</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>14</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E 831</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for<br />Linear Thermal Expansion<br />of Solid Materials by<br />Thermomechanical Analysis</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1260</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>15</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>AATCC 6538</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Staphylococcus aureus<br />Antibacterial Activity<br />Assessment of Textile Materials</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>3600</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>16</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ISO 6330 (5 wash)</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Tekstil- Tekstil deneyleri için- Ev <br />tipi çamaşır makinesi ile yıkama <br />ve kurutma işlemleri</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Textiles – Domestic washing and <br />drying procedures for textile testing</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>180</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>17</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E1269, ASTM D 27668 (liquids and solids)</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for<br />Determining Specific Heat<br />Capacity by Differential<br />Scanning Calorimetry</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>–</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>18</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>—</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Kumaş Sterilizasyon (5 adet)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>216</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>19</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 5034-ISO 1798 (polimerik kompozit)</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Polimerik malzemeler – Esnek –<br />Gözenekli – Çekme mukavemeti ve<br />kopma anındaki uzamanın tayini</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Breaking Strength and<br />Elongation of Textile Fabrics (Grab Test)<br />TS EN ISO 1798<br />Flexible cellular polymeric materials –<br />Determination of tensile strength and elongation at break</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>468</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>20</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 2261, ISO 5088</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Tearing Strength of Fabrics<br />(Single Rip) Procedure (Constant-Rate-of-Extension Tensile Testing Machine)<br />ISO 5082:1982<br />Textiles – Woven fabrics – Determination of breaking strength – Grab method</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>360</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>21</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 3886</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance of Textile Fabrics (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance of Textile Fabrics (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>22</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>IEC 61340, ANSI ESD/STM 2.1, ASTM F 365, IEC 61340-4-9, IEC 61340-5-1</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Noktadan Noktaya Direnc Testi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Electrostatics – Protection of electronic devices from electrostatic phenomena,<br />ANSI/ESD STM 2.1:2013 ESD Association Standard Test Method for Protection of ESD Susceptible Items – Garments – Resistive Characterization</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1410</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>23</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>EN 20811, AATC 127, ISO 811</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Su direnci: hidrostatik Basınç testi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Water Resistance: Hydrostatic Pressure Test</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>24</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 629</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Methods for Quantitative Analysis of Textiles</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>576</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>25</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ISO 15025</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Koruyucu giyecekler – Electrostatic properties – Bölüm 1:<br />Yüzey öz direnci (deney metotları ve kurallar)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Protective clothing – Electrostatic properties – Part 1:<br />Surface resistivity (test methods and requirements)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>468</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>26</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 3886</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance of Textile Fabrics (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance of Textile Fabrics (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>27</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM E 168, E 1252</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Practices for General Techniques of Infrared Quantitative Analysis<br />ASTM E1252 – 98(2013)e1<br />Standard Practice for General Techniques for Obtaining Infrared Spectra for Qualitative Analysis</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1260</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>28</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>—</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Kumaş Sterilizasyon (5 adet)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>216</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>29</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>TS EN 29865</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Tekstil mamulleri – Kumaşlarda su iticiliği tayini – Bundesmann yağmur-Duş metodu</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Textiles – Determination of Water Repellency of Fabrics by the Bundesmann Rain-Shower Test</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>2340</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>30</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 2261, ISO 5082</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Tearing Strength of Fabrics<br />(Single Rip) Procedure (Constant-Rate-of-Extension Tensile Testing Machine)<br />ISO 5082:1982</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>360</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>31</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>ASTM D 3886</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Standard Test Method for Abrasion Resistance (Inflated Diaphragm Apparatus)</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>32</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>IEC 61340, ANSI ESD/STM 2.1, ASTM F 365, IEC 61340-4-9, IEC 61340-5-1</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Noktadan Noktaya Direnc Testi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Electrostatics – Protection of electronic devices from electrostatic phenomena,<br />ANSI/ESD STM 2.1:2013</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>1410</center></div></div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>33</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>EN 20811, AATC 127, ISO 811</center></div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Su direnci: hidrostatik Basınç testi</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content">
          <h6 style="text-align: center;">Water Resistance: Hydrostatic Pressure Test</h6>
        </div></div>
      </td>
      <td>
        <div class="td-content-wrapper"><div class="td-content"><center>432</center></div></div>
      </td>
    </tr>
  </tbody>
</table>
  `;

  return (
    <div className="malzeme-test-ve-analizleri-page">
      {/* Banner */}
      <Banner 
        title="Malzeme Test ve Analizleri" 
        backgroundImage="https://teknoma.net/wp-content/themes/bizler/assets/img/inner-banner.jpg"
      />

      {/* Page Content */}
      <section className="malzeme-test-ve-analizleri-content">
        <div className="container content-container">
          {/* Introduction Section */}
          <div className="section introduction">
            <p>
              TeknoMa Teknolojik Malzemeler, malzemelerin termal, elektriksel, elektromanyetik ve mekanik özelliklerinin detaylı test ve analizlerini gerçekleştirir.
              Aşağıda çeşitli test yöntemleri ve analizlerin fiyat listesi yer almaktadır.
            </p>
          </div>

          {/* EM Kalkanlama Table Section */}
          <div className="section em-kalkanlama-table-section">
            <div dangerouslySetInnerHTML={{ __html: emCalkanlamaTableHTML }} />
          </div>

          {/* Data Table Section */}
          <div className="section data-table-section">
            <div dangerouslySetInnerHTML={{ __html: dataTableHTML }} />
          </div>

          {/* Notes Section */}
          <div className="section notes">
            <ul>
              <li><strong>Fiyatlara %20 KDV eklenecektir.</strong></li>
              <li><strong>Listede olmayan testler için lütfen info@teknoma.net'e e-mail atınız.</strong></li>
              <li><strong>Test süreleri 1 ile 4 hafta arasındadır.</strong></li>
              <li><strong>Aynı testten 5 adet ve fazlası için %15 indirim uygulanır.</strong></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MalzemeTestVeAnalizleri;